function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.75 12C10.0637 12 12.75 9.31371 12.75 6C12.75 2.68629 10.0637 0 6.75 0C3.43629 0 0.75 2.68629 0.75 6C0.75 9.31371 3.43629 12 6.75 12Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.34921 3.87039L6.74994 5.46967L5.15066 3.87039C5.00482 3.72455 4.76617 3.72455 4.62033 3.87039C4.47449 4.01623 4.47449 4.25488 4.62033 4.40072L6.21961 6L4.62033 7.59928C4.47449 7.74512 4.47449 7.98377 4.62033 8.12961C4.69325 8.20253 4.78937 8.23899 4.88549 8.23899C4.98162 8.23899 5.07774 8.20253 5.15066 8.12961L6.74994 6.53033L8.34921 8.12961C8.42213 8.20253 8.51826 8.23899 8.61438 8.23899C8.7105 8.23899 8.80662 8.20253 8.87954 8.12961C9.02538 7.98377 9.02538 7.74512 8.87954 7.59928L7.28027 6L8.87954 4.40072C9.02538 4.25488 9.02538 4.01623 8.87954 3.87039C8.7337 3.72455 8.49505 3.72455 8.34921 3.87039Z",
  fill: "white"
});

var SvgRemove = function SvgRemove(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRemove, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/remove.2e4c1935.svg";
export { ForwardRef as ReactComponent };